// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app{height:100vh;font-family:Avenir,Helvetica,Arial,sans-serif}body,textarea{font-family:Microsoft YaHei,微软雅黑,Arial,Helvetica,sans-serif,宋体}.el-table .cell{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}::-webkit-scrollbar{width:8px}::-webkit-scrollbar-thumb{background-color:#eaecf1;border-radius:3px}", ""]);
// Exports
module.exports = exports;
